// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  onConfirm: () => void,
  onHide: () => void,
|};

export default function OverwriteWarningModal({ onConfirm, onHide }: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('Close', 'Close button for board order overwrite modal')}
      accessibilityModalLabel={i18n._(
        'Warning about overwriting board order',
        'Accessible label for the board order overwrite modal',
      )}
      onDismiss={onHide}
      heading={i18n._('Are you sure?', 'Heading for board order overwriting modal')}
      role="alertdialog"
      size="md"
      footer={
        <Box display="flex" marginLeft={-1} marginRight={-1} justifyContent="end">
          <Box padding={1}>
            <Button
              size="lg"
              text={i18n._('Cancel', 'Button text for canceling board re-ordering')}
              onClick={onHide}
            />
          </Box>
          <Box padding={1}>
            <Button
              size="lg"
              color="red"
              text={i18n._(
                'Lose previous customization',
                'Button text for confirming board re-ordering',
              )}
              onClick={onConfirm}
            />
          </Box>
        </Box>
      }
    >
      <Box padding={4}>
        <Text>
          {interpolateNamedTemplate(
            i18n._(
              'You’re about to re-sort your boards. This will lose the custom board order you previously created using {{ dragAndDrop }}',
            ),
            {
              dragAndDrop: (
                <Text inline key="dragDrop" weight="bold">
                  {i18n._('Drag and drop', 'Text for indicating drag and drop sort order')}
                </Text>
              ),
            },
          )}
        </Text>
      </Box>
    </Modal>
  );
}
